// import * as React from "react";
// import FilterGrnSearch from "./FilterGrnSearch";
// import { AnyForNow } from "../../features/grn/types";

// /**
//  * Return GRN Search Filter Component
//  * Wrapper around FilterGrnSearch with includeReturnId=true
//  */
// interface FilterReturnGrnSearchProps extends AnyForNow {}

// const FilterReturnGrnSearch: React.FC<FilterReturnGrnSearchProps> = (props) => {
//   return (
//     <FilterGrnSearch
//       {...props}
//       includeReturnId={true}
//     />
//   );
// };

// export default FilterReturnGrnSearch;


import * as React from "react";


import MultipleReturnSearchFilter from "../common/MultipleReturnSearchFilter";
import { useFilters } from "../../hooks/useFilters";
import { AnyForNow } from "../../features/grn/types";
import FilterBarrtn from "../common/FilterBarrtn";


/**
 * Consolidated GRN Search Filter Component
 * @param {Object} props - Component props
 * @param {Array} props.warehouseOptions - Warehouse options for dropdown
 * @param {Array} props.grnStatusTypes - Status types for dropdown
 * @param {function} props.onFilterChange - Callback when filters change
 * @param {boolean} props.disableStatusField - Whether to disable status field
 * @param {boolean} props.includeReturnId - Whether to include return ID field
 */

interface FilterGrnSearchProps {
  warehouseOptions?: AnyForNow[];
  grnStatusTypes?: AnyForNow[];
  onFilterChange?: (filters: AnyForNow) => void;
  disableStatusField?: boolean;
  includeReturnId?: boolean;
  searchFields?: { label: string; value: string }[]; // ✅ dynamic search fields  
}
const FilterReturnGrnSearch: React.FC<FilterGrnSearchProps> = (props) => {
  const {
    warehouseOptions = [],
    grnStatusTypes = [],
    onFilterChange = () => {},
    disableStatusField = false,
    includeReturnId = false,
    searchFields = []
  } = props;

const initialFilters: AnyForNow = {
  searchType: "grnId",   // ✅ default
  searchValue: "",       // ✅ actual input
  warehouse: "",
  status: "",
  fromDate: null,
  toDate: null,
  ...(includeReturnId && { grnreturncode: "" })
};

  const { filters, updateFilter, updateFilters, clearFilters } = useFilters(initialFilters);

const handleFilterChange = (newFilters: AnyForNow) => {
  updateFilters(newFilters);

  // 🔥 Transform dynamic search → API format
  const transformedFilters = { ...newFilters };

  if (newFilters.searchType && newFilters.searchValue) {
    transformedFilters[newFilters.searchType] = newFilters.searchValue;
  }

  onFilterChange(transformedFilters);
};

  const handleClearFilters = () => {
    clearFilters();
    const clearedFilters = { ...initialFilters };
    onFilterChange(clearedFilters);
  };

  const extraFields = includeReturnId ? [{ name: "grnreturncode", label: "Return ID" }] : [];

  return (
    <FilterBarrtn
      filters={filters}
      onFilterChange={handleFilterChange}
      warehouseOptions={warehouseOptions}
      statusTypes={grnStatusTypes}
      disableStatusField={disableStatusField}
      extraFields={extraFields}
      searchFields={searchFields}
    />
  );
};

export default FilterReturnGrnSearch;
